module.exports = __webpack_public_path__ + "static/media/support_center.d98eece7.svg";